const searchApies = document.querySelectorAll("[data-search-api]");

for (const searchApi of searchApies) {
  const inputSearch = searchApi.querySelector("[data-input-search]");
  const inputSearchList = searchApi.querySelector("[data-input-search-list]");
  const InputSearchReset = searchApi.querySelector("[data-input-search-reset]");

  function removeListItems() {
    inputSearch.classList.remove("open");
    inputSearchList.querySelectorAll("div, a").forEach((a) => {
      a.remove();
    });
  }

  function debounce(func, wait, immediate) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  if (InputSearchReset) {
    InputSearchReset.addEventListener("click", () => {
      removeListItems();
      inputSearch.value = "";
      inputSearch.setAttribute("value", "");
      inputSearch.focus()
    });
  }

  const debouncedFetch = debounce((e) => {
    removeListItems();
    const inputValue = e.target.value;

    if (inputValue.length >= 3) {
      const apiUrl = inputSearch.getAttribute("data-api_url");
      const termId = inputSearch.getAttribute("data-api-term-id")??'';
      const urlParts = apiUrl.split("search=");
      urlParts[1] = urlParts[1] === undefined ? '' : urlParts[1];

    //   const newUrl= urlParts[0].includes('?')
    //       ? urlParts[0] + "&search=" + inputValue + urlParts[1]
    //       : urlParts[0] + "?search=" + inputValue + urlParts[1];

    const newUrl = urlParts[0].includes('?')
        ? `${urlParts[0]}&search=${inputValue}&termId=${termId}${urlParts[1]}`
        : `${urlParts[0]}?search=${inputValue}&termId=${termId}${urlParts[1]}`;

      fetchDataFromAPI(newUrl);
    }
  }, 300);

  if (inputSearch) {
    inputSearch.addEventListener("input", debouncedFetch);
  }

  function fetchDataFromAPI(url) {
    fetch(url, {
      method: "GET",
      headers: {"Content-Type": "application/json"},
    })
        .then((response) => response.json())
        .then((data) => populateListWithData(data.items))
        // .then(data => console.log(data))
        .catch((error) => console.error("Error:", error));
  }

  function populateListWithData(items) {
    inputSearch.classList.add("open");

    if (items.length === 0) {
      inputSearchList.insertAdjacentHTML(
          "beforeend",
          "<div class=\"text-gray\">За вашим запитом не знайдено результатів. Переконайтесь, що дані введено правильно та спробуйте ще раз</div>",
      );
    }

    items.forEach((item) => {
      const {title, url, price, code, icon, avatar, avatar_alt, job_title, name, image, image_alt, href, date_published_at, path} = item;

      if (item) {
        const searchType = inputSearch.getAttribute("data-input-search");
        const specialText = inputSearch.getAttribute("data-input-special-text")??"Зображення";

        if (searchType === "service") {
          inputSearchList.insertAdjacentHTML(
              "beforeend",
              `<a class="d-flex justify-content-between flex-gap-12" href="${url}">
                <div class="text-line-clamp-3">${title}</div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="title-h3 mb-4 text-nowrap">${price}</div>
                  <div class="text-sm text-capture text-bold">${code}</div>
                </div>
              </a>`,
          );
        } else if (searchType === "additional-service" && image !== null) {
            inputSearchList.insertAdjacentHTML(
                "beforeend",
                `<a class="d-flex flex-gap-12" href="${url}">
                <div class="img-64 img-sm-88">
                  <div class="block-img block-img_67">
                    <img src="${image}" alt="${title}">
                  </div>
                </div>
                <div class="flex-grow-1 text-line-clamp-3">${title}</div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="title-h3 mb-4 text-nowrap">${price}</div>
                </div>
              </a>`,
            );
        } else if (searchType === "additional-service" && image !== null) {
            inputSearchList.insertAdjacentHTML(
                "beforeend",
                `<a class="d-flex flex-gap-12" href="${url}">
                <div class="img-64 img-sm-88">
                  <div class="block-img block-img_eclipse block-img_67 bg-white">
                    <div class="block-img__plug background-decoration_5 bg-main-color-40"></div>
                    <div class="block-img__plug-text text-sm text-bold text-center">Додаткова послуга</div>
                  </div>
                </div>
                <div class="flex-grow-1 text-line-clamp-3">${title}</div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="title-h3 mb-4 text-nowrap">${price}</div>
                </div>
              </a>`,
            );
        } else if (searchType === "package" && icon !== null) {
          inputSearchList.insertAdjacentHTML(
              "beforeend",
              `<a class="d-flex flex-gap-12" href="${url}">
                <div class="img-64 img-sm-88">
                  <div class="block-img block-img_67">
                    <img src="${icon}" alt="${title}">
                  </div>
                </div>
                <div class="flex-grow-1 text-line-clamp-3">${title}</div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="title-h3 mb-4 text-nowrap">${price}</div>
                  <div class="text-sm text-capture text-bold">${code}</div>
                </div>
              </a>`,
          );
        } else if (searchType === "package" && icon === null) {
            inputSearchList.insertAdjacentHTML(
                "beforeend",
                `<a class="d-flex flex-gap-12" href="${url}">
                <div class="img-64 img-sm-88">
                  <div class="block-img block-img_eclipse block-img_67 bg-white">
                    <div class="block-img__plug background-decoration_5 bg-main-color-40"></div>
                    <div class="block-img__plug-text text-sm text-bold text-center">Пакет послуг</div>
                  </div>
                </div>
                <div class="flex-grow-1 text-line-clamp-3">${title}</div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="title-h3 mb-4 text-nowrap">${price}</div>
                  <div class="text-sm text-capture text-bold">${code}</div>
                </div>
              </a>`,
            );
        } else if (searchType === "doctor") {
          inputSearchList.insertAdjacentHTML(
              "beforeend",
              `<a class="d-flex flex-gap-12" href="${url}">
                <div class="img-36 img-sm-56">
                  <div class="block-img">
                    <img src="${avatar}" alt="${avatar_alt}">
                  </div>
                </div>
                <div>
                  <div class="text-sm text-capture text-bold mb-2">${job_title}</div>
                  <div>${name}</div>
                </div>
              </a>`,
          );
        // } else if ((searchType === "news" && image !== null) || (searchType === "importantInfo" && image !== null) || (image !== "") || (image !== undefined)) {
        } else if ((searchType === "news" || searchType === "importantInfo" || searchType === "rehabilitation") && (image !== null && image !== "") ) {
            inputSearchList.insertAdjacentHTML(
              "beforeend",
              `<a class="d-flex flex-gap-12" href="${href}">
                <div class="img-64 img-sm-88">
                  <div class="block-img block-img_67">
                    <img src="${image}" alt="${image_alt}">
                  </div>
                </div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="text-bolder mb-4 text-line-clamp-3">${title}</div>
                  <div class="d-flex align-items-center">
                    <svg class="img-16 mr-4" width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33398 7.8525C1.33398 4.17342 4.31398 1.1875 7.99398 1.1875C11.6807 1.1875 14.6673 4.17342 14.6673 7.8525C14.6673 11.5316 11.6807 14.5175 7.99398 14.5175C4.31398 14.5175 1.33398 11.5316 1.33398 7.8525ZM2.66797 7.85264C2.66797 10.7986 5.05464 13.1846 8.0013 13.1846C10.948 13.1846 13.3346 10.7986 13.3346 7.85264C13.3346 4.90671 10.948 2.52064 8.0013 2.52064C5.05464 2.52064 2.66797 4.90671 2.66797 7.85264Z" fill="#C0C0C0"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66732 4.34619H7.33398V9.01519H7.33414L10.7982 11.0162L11.4648 9.86088L8.66732 8.24491V4.34619Z" fill="#C0C0C0"/>
                    </svg>
                    <div class="text-sm text-gray2">${date_published_at}</div>
                  </div>
                </div>
              </a>`,
          );
        // } else if (searchType === "news" && image === null) {
        } else if ((searchType === "news" || searchType === "importantInfo" || searchType === "rehabilitation") && (image === null || image === "")) {
            let options = {
                news:'Новина',
                importantInfo:'Важлива інформація',
                rehabilitation:'Програма реабілітації',
            };
            let special_text = specialText??options[searchType];
            inputSearchList.insertAdjacentHTML(
                "beforeend",
                `<a class="d-flex flex-gap-12" href="${href}">
                <div class="img-64 img-sm-88">
                  <div class="block-img block-img_eclipse block-img_67 bg-white">
                    <div class="block-img__plug background-decoration_5 bg-main-color-40"></div>
                    <div class="block-img__plug-text text-sm text-bold text-center">${special_text}</div>
                  </div>
                </div>
                <div class="d-flex flex-column justify-content-between">
                  <div class="text-bolder mb-4 text-line-clamp-3">${title} </div>
                  <div class="d-flex align-items-center">
                    <svg class="img-16 mr-4" width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33398 7.8525C1.33398 4.17342 4.31398 1.1875 7.99398 1.1875C11.6807 1.1875 14.6673 4.17342 14.6673 7.8525C14.6673 11.5316 11.6807 14.5175 7.99398 14.5175C4.31398 14.5175 1.33398 11.5316 1.33398 7.8525ZM2.66797 7.85264C2.66797 10.7986 5.05464 13.1846 8.0013 13.1846C10.948 13.1846 13.3346 10.7986 13.3346 7.85264C13.3346 4.90671 10.948 2.52064 8.0013 2.52064C5.05464 2.52064 2.66797 4.90671 2.66797 7.85264Z" fill="#C0C0C0"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66732 4.34619H7.33398V9.01519H7.33414L10.7982 11.0162L11.4648 9.86088L8.66732 8.24491V4.34619Z" fill="#C0C0C0"/>
                    </svg>
                    <div class="text-sm text-gray2">${date_published_at}</div>
                  </div>
                </div>
              </a>`,
            );
        } else if (searchType === "docs") {
          inputSearchList.insertAdjacentHTML(
              "beforeend",
              `<a class="d-flex justify-content-between align-items-center link-load-file" href="${path}" target="_blank">
                <div class="mr-16 text-main-color text-line-clamp-3">${title}</div>
                <svg class="img-24" width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="1.30176" width="39" height="39" rx="7.5" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 10.8018H22L28 16.8018V28.8018C28 29.9018 27.1 30.8018 26 30.8018H13.99C12.89 30.8018 12 29.9018 12 28.8018L12.01 12.8018C12.01 11.7018 12.9 10.8018 14 10.8018ZM14 12.8018V28.8018H26V17.8018H21V12.8018H14Z" fill="#67BDA7"/>
                    <path d="M9.99 19.8018C8.89 19.8018 8 20.7018 8 21.8018V25.8018C8 26.9018 8.89 27.8018 9.99 27.8018H30C31.1 27.8018 32 26.9018 32 25.8018V21.8018C32 20.7018 31.1 19.8018 30 19.8018H9.99Z" fill="#67BDA7"/>
                    <path d="M15.4175 26.3014H14.4375V21.4014H15.9425C16.4232 21.4014 16.8105 21.5344 17.1045 21.8004C17.3985 22.0664 17.5455 22.4234 17.5455 22.8714C17.5455 23.3194 17.3985 23.6764 17.1045 23.9424C16.8105 24.2084 16.4232 24.3414 15.9425 24.3414H15.4175V26.3014ZM15.9425 22.2064H15.4175V23.5364H15.9425C16.1292 23.5364 16.2785 23.4757 16.3905 23.3544C16.5072 23.233 16.5655 23.072 16.5655 22.8714C16.5655 22.6707 16.5072 22.5097 16.3905 22.3884C16.2785 22.267 16.1292 22.2064 15.9425 22.2064Z" fill="white"/>
                    <path d="M19.9268 26.3014H18.1768V21.4014H19.9268C20.6781 21.4014 21.2871 21.623 21.7538 22.0664C22.2158 22.5097 22.4468 23.1047 22.4468 23.8514C22.4468 24.598 22.2158 25.193 21.7538 25.6364C21.2871 26.0797 20.6781 26.3014 19.9268 26.3014ZM19.9268 22.2064H19.1568V25.4964H19.9268C20.3841 25.4964 20.7551 25.347 21.0398 25.0484C21.3244 24.7497 21.4668 24.3507 21.4668 23.8514C21.4668 23.3567 21.3244 22.96 21.0398 22.6614C20.7504 22.358 20.3794 22.2064 19.9268 22.2064Z" fill="white"/>
                    <path d="M25.7031 22.1714H24.0231V23.4664H25.4931V24.2364H24.0231V26.3014H23.0781V21.4014H25.7031V22.1714Z" fill="white"/>
                    <rect x="0.5" y="1.30176" width="39" height="39" rx="7.5" stroke="#67BDA7"/>
                </svg>
              </a>`,
          );
        }
      }
    });
  }
}
